import { Flex, Form } from "antd";
import { useWatch } from "antd/es/form/Form";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { SaveConfig } from "../../..";
import { PathContext } from "../../../context/PathContext";
import { MetaFieldDescription } from "./MetaFieldDescription";
import { MetaFieldLabel } from "./MetaFieldLabel";
import { MetaFieldNameInput } from "./MetaFieldNameInput";
import { MetaFieldTypeOptions } from "./MetaFieldTypeOptions";
import { MetaFieldTypeSelect } from "./MetaFieldTypeSelect";

type Props = {
  index: number;
};

export const MetaFieldConfig = observer((props: Props) => {
  const path = useContext(PathContext);
  const config = useWatch<SaveConfig, SaveConfig["config"]>(
    (values) => values?.config
  );
  const meta = config?.find((field) => field.name === "meta");
  const field = meta?.fields?.[props.index];
  const name = field?.label?.trim().toLowerCase().replace(/\s+/g, "_");

  const isDuplicateName = meta?.fields?.some(
    (f) =>
      f?.label?.trim().toLowerCase().replace(/\s+/g, "_") === name &&
      f !== field
  );

  let error = undefined;
  if (isDuplicateName)
    error =
      "maintenance:ticket.creation.config.form.field.meta.error.duplicate";

  return (
    <div style={{ width: "100%" }}>
      <Form.Item name={[...path, "name"]} initialValue={name}>
        <MetaFieldNameInput name={name} error={error} />
      </Form.Item>

      <Flex justify="space-between" gap="small">
        <MetaFieldLabel />
        <MetaFieldDescription />
      </Flex>
      <Flex justify="space-between" gap="small">
        <MetaFieldTypeSelect />
        <MetaFieldTypeOptions field={meta?.fields?.[props.index]} />
      </Flex>
    </div>
  );
});
